import { UserTypes } from "shared-types";
import { getUserAttribute, UserAttributes } from "../services/authorization";

/**
 * Checks if the user is a young performer based on the artist type or publication code.
 * @param artistType - The artist type to check. Get from viewPin for public profile view.
 * Otherwise, get from publication code inside JWT claims.
 *
 * @returns True if the user is a young performer, false otherwise.
 */

export function checkIsYp(artistType?: UserTypes) {
  const value =
    artistType !== undefined && artistType !== null
      ? Number(artistType)
      : Number(getUserAttribute(UserAttributes.PublicationCode));

  return (
    value === UserTypes.youngPerformerFemale ||
    value === UserTypes.youngPerformerMale
  );
}
